export class DayBookingSaveData {
    id?: string;
    employeeId?: string;
    rowId?: string;
    dayBookingTypeId: string;
    costCenterId?: string;
    vehicleId?: string;
    day: string;
    amount: number;
    dayUsageType?: number;
    comment?: string;
    automaticCategory?: string;
    automaticWorkShiftTimeSlotId?: string;
}
